import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogOut } from 'lucide-react';
import { useAuthStore } from '../store';
import { Button } from './ui/button';

// Barra fija mientras una CEO "ve el portal como" otro miembro
export function ImpersonationBanner() {
  const navigate = useNavigate();
  const { impersonation, user, stopImpersonating } = useAuthStore();
  if (!impersonation) return null;
  const clientView = user?.role === 'client';
  const back = () => {
    stopImpersonating();
    navigate(clientView ? '/service-delivery' : '/ceo-dashboard');
  };
  return (
    <div
      className="sticky top-0 z-40 flex flex-wrap items-center justify-between gap-2 px-6 py-2 bg-amber-400 text-amber-950 text-sm shadow-sm"
      role="status"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4" />
        {clientView ? (
          <span data-testid="client-view-mode-label">
            <strong>MODO VISTA DE CLIENTE</strong> · Estás viendo el portal de <strong data-testid="impersonation-target">{user?.name}</strong> tal y como lo ve. Solo lectura: no puedes aprobar, pedir cambios ni modificar nada.
          </span>
        ) : (
        <span>
          Estás viendo el portal como <strong data-testid="impersonation-target">{user?.name}</strong>
          <span className="opacity-80"> ({user?.email})</span> · las acciones se hacen en su nombre (sesión auditada, acceso iniciado por {impersonation.originalUser?.name})
        </span>
        )}
      </div>
      <Button size="sm" variant="outline" className="h-7 bg-white/70 hover:bg-white border-amber-600/30 text-amber-950" onClick={back} data-testid="impersonation-exit-btn">
        <LogOut className="w-3.5 h-3.5 mr-1" /> Volver a mi cuenta
      </Button>
    </div>
  );
}
